__turbopack_context__.v({
  "billingActions": "ManagedEntry-module__DKeciG__billingActions",
  "card": "ManagedEntry-module__DKeciG__card",
  "center": "ManagedEntry-module__DKeciG__center",
  "editor": "ManagedEntry-module__DKeciG__editor",
  "editorBar": "ManagedEntry-module__DKeciG__editorBar",
  "editorBody": "ManagedEntry-module__DKeciG__editorBody",
  "eyebrow": "ManagedEntry-module__DKeciG__eyebrow",
  "grid": "ManagedEntry-module__DKeciG__grid",
  "header": "ManagedEntry-module__DKeciG__header",
  "nav": "ManagedEntry-module__DKeciG__nav",
  "org": "ManagedEntry-module__DKeciG__org",
  "portal": "ManagedEntry-module__DKeciG__portal",
  "versions": "ManagedEntry-module__DKeciG__versions",
});
